var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer bg-white py-4 d-flex flex-lg-column",attrs:{"id":"kt_footer"}},[_c('div',{staticClass:"d-flex align-items-center justify-content-between",class:{
            'container-fluid': _vm.widthFluid,
            container: !_vm.widthFluid,
        }},[_c('div',{staticClass:"text-dark"},[_c('span',{staticClass:"text-muted font-weight-bold mr-2"},[_vm._v(" "+_vm._s(_vm.currentYear)+"  ©  ")]),_c('span',[_vm._v("Consiliul Judetean Cluj")])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }